import { Navbar, NavDropdown } from "react-bootstrap";
import styled from "styled-components";

export const styles = {
  container: {
    background: "#0a3949",
    color: "#fff",
    fontWeight: 400,
    fontSize: 16,
    borderRadius: 0,
    border: 0,
    padding: 13,
  },
  link: {
    position: "relative",
    top: 14,
    color: "#fff",
  },
  logo: {
    padding: "4px 0",
    marginLeft: "0px",
  },
  toggle: {
    border: "#27a338",
    background: "#27a338",
  },
  avatar: {
    float: "right",
    position: "relative",
    left: -12,
    top: -14,
  },
};

export const StyledNavbar = styled(Navbar)`
  @media screen and (max-width: 767px) {
    padding: 13px 4px !important;
  }
`;

export const Container = styled.div`
  min-width: 375px;
  font-family: "Raleway";
  text-decoration: none;
  color: #fff;
  .navbar-collapse a,
  .navbar-collapse span,
  .navbar-collapse .open {
    text-decoration: none;
    background: transparent !important;
    &:hover {
      color: #39b54a !important;
    }
  }

  .header.navbar-default .navbar-nav > li > a,
  .header.navbar-default .navbar-nav > li > ul > li > a {
    color: #fff;
  }

  .header.navbar-default .navbar-toggle .icon-bar {
    background: #fff;
  }

  .nav {
    @media screen and (max-width: 767px) {
      width: 54%;
      padding: 10px;
    }
    @media screen and (max-width: 1200px) {
      padding: 0;
      width: auto;
    }

    li {
      @media screen and (max-width: 767px) {
        color: #fff;
        text-decoration: none;
        padding: 0 20px;
        a {
          outline: none;
        }
        :hover {
          color: #39b54a;
        }
      }
      @media screen and (max-width: 1200px) {
        padding: 0;
        margin: 0;
      }
    }
  }
`;

export const DropdownStyle = styled.span`
  width: 179px;
  display: inline-block;
`;

export const Dropdown = styled(NavDropdown)`
  a {
    height: 0;
    color: #fff;
  }
  ul {
    background: #0a3949;
    position: absolute;
    top: 50px;
  }
  li {
    height: 30px;
  }
  .dropdown-menu > li > a {
    color: #fff;
  }
`;

export const Logo = styled.div`
  .navbar-header {
    margin-right: 20px;
  }

  @media screen and (max-width: 767px) {
    .navbar-header {
      margin-right: 0px;

      button {
        margin: 10px 0 0 0;
      }
    }
  }
`;
